import React, { useEffect, useState, useRef } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import VideoPreview from "./components/VideoPreview";

function Article() {
  const { articleID } = useParams();
  const location = useLocation();
  const videoRef = useRef(null);

  const prevQuery = (location.state && (location.state.prevQuery || location.state.query)) || '';
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Read start time from URL query parameter `?t=`
  const searchParams = new URLSearchParams(location.search);
  const startTime = searchParams.get('t');

  const fetchArticle = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`/api/searchByArticleID?articleID=${articleID}`);
      if (!res.ok) throw new Error('Network response was not ok');
      const body = await res.json();
      setItem(body || {});
    } catch (err) {
      setError(err.message || 'Error loading');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticle();
    // eslint-disable-next-line
  }, [articleID]);

  // Effect to update document title
  useEffect(() => {
    if (item && item.title) {
      document.title = item.title;
    }
  }, [item]);

  // Effect to handle seeking the video to the start time
  useEffect(() => {
    if (item && item.videoUrl && videoRef.current && startTime) {
      const timeInSeconds = parseInt(startTime, 10);
      if (!isNaN(timeInSeconds)) {
        const handleSeek = () => {
          videoRef.current.currentTime = timeInSeconds;
        };
        videoRef.current.addEventListener('loadedmetadata', handleSeek);

        return () => {
          if (videoRef.current) {
            // eslint-disable-next-line
            videoRef.current.removeEventListener('loadedmetadata', handleSeek);
          }
        };
      }
    }
  }, [item, startTime]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      padding: 20,
      backgroundColor: 'black',
      color: 'gold',
    }}>
      {loading && <p>Loading...</p>}
      {item && (
        <>
          <div style={{
            marginBottom: 20,
            display: 'flex',
            alignItems: 'center',
            gap: 20
          }}>
            <Link
              to={prevQuery ? "/aisearch" : "/"}
              state={{ query: prevQuery }}
              style={{ color: 'green', textDecoration: 'none' }}
            >
              {prevQuery ? "← back to search" : "← Go to site sections"}
            </Link>
            <h2 style={{ margin: 0 }}>Articles by author: {item.authorName}</h2>
          </div>

          {error && <p style={{ color: 'red' }}>{error}</p>}

          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 16
          }}>
            {/* Media Content: Video or Image */}
            <div style={{
              width: '100%',
              margin: '0 auto',
              borderRadius: 8,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              background: '#000' // Black background for video player
            }}>
              {item.videoUrl ? (
                  <VideoPreview  existingVideoUrl={item.videoUrl} />

              ) : item.imageUrl && (
                <img
                  src={item.imageUrl}
                  alt=""
                  style={{
                    width: 'auto',
                    maxHeight: '40vh',
                    display: 'block',
                    margin: '0 auto'
                  }}
                />
              )}
            </div>

            {/* Article Text */}
            <div style={{
              flex: 1,
              background: '#fff',
              color: "black",
              border: '1px solid #ddd',
              borderRadius: 8,
              padding: 24,
              overflow: 'auto',
            }}>
              <div 
                style={{
                  lineHeight: 1.6,
                  fontSize: '16px'
                }}
                dangerouslySetInnerHTML={{ __html: item.text }} 
              />
            </div>


            {/* Links */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
              marginTop: 20
            }}>
              <Link
                to={`/category/${encodeURIComponent(item.categoryID)}/${encodeURIComponent(item.categoryName)}`}
                state={{ prevQuery: prevQuery }}
                style={{ color: 'green', textDecoration: 'none' }}
              >
                All articles on topic "{item.categoryName}"
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Article;
